/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Transfer between main account and its subaccount
 */
export interface SubAccountTransferCreationRequest {
  /**
   * Source account ID
   */
  fromAccountId: number;
  /**
   * Destination account ID
   */
  toAccountId: number;
  assetId: number;
  quantity: number;
  /**
   * Note visible to client
   */
  noteForClient?: string;
}
